import Vue from "vue";
import Router from "vue-router";
// import { Store } from "vuex";
Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [{
            path: "/",
            name: "home",
            props: true,
            component: () =>
                import ("./../src/components/LandingPage.vue"),
        },
        {
            path: "/contactUs",
            name: "ContactUs",
            props: true,
            component: () =>
                import ("./../src/components/ContactUs/contactUs"),
        },
        {
            path: "/coursesPage",
            name: "CoursesPage",
            props: true,
            component: () =>
                import ("./../src/components/Courses/coursesPage"),
        },
        {
            path: "/courseDetails",
            name: "courseDetails",
            props: true,
            component: () =>
                import ("./../src/components/Courses/courseDetails"),
        },
        {
            path: "/privacypolicy",
            name: "privacypolicy",
            props: true,
            component: () =>
                import ("./../src/components/PrivacypolicyPage.vue"),
        },
        {
            path: "/termsandconditions",
            name: "termsandconditions",
            props: true,
            component: () =>
                import ("./../src/components/termsandService.vue"),
        },
        {
            path: "/ourworks",
            name: "ourworks",
            props: true,
            component: () =>
                import ("./../src/components/OurWorks.vue"),
        },
        {
            path: "/gallery",
            name: "gallery",
            props: true,
            component: () =>
                import ("./../src/components/GalleryPage.vue"),
        },


    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },

});



// router.beforeEach((to, from, next) => {
//   if (
//     to.matched.some((route) => route.meta.requiresAuth == true) &&
//     store.state.isLoggedIn == false
//   ) {
//     console.log(from);
//     next({ name: "login", params: { lastPage: from } });
//     return;
//   }


//   next();
// });

export default router;